import {TimelineMax, TweenLite} from 'gsap';
const Shortcuts = require('../utils/Shortcuts');

const win = window;

function GallerySliderTimeline(selector, refDuration) {

    const constructor = {};
    let _created = false;

    constructor.create = () => {
        if (_created) return constructor.instance.timeline;

        TweenLite.set(selector, {opacity: 1});

        const obj = {progress: 0, on: false, element: document.querySelector(selector), items: [...document.querySelectorAll(selector + ' .js--item')], container: document.querySelector(selector + ' .js--container')};
        constructor.obj = obj;
        constructor.update = () => {
            const obj = constructor.obj;
            obj.container.style.transform = `translate3d(0, ${obj.y0 - obj.deltaH * obj.progress}px, 0)`;

            const nFloat = obj.progress * (obj.items.length - 1);

            const curI = Math.round(nFloat);
            obj.items.forEach((el, index) => {
                el.classList.remove('active');
                el.style.opacity = 1 - 0.65 * Math.min(1, Math.abs(nFloat - index));
            });
            obj.items[curI].classList.add('active');



        };
        constructor.initParams = () => {
            const obj = constructor.obj;
            const rect0 = obj.items[0].getBoundingClientRect();
            const rect1 = obj.items[1].getBoundingClientRect();
            obj.itemH = rect0.height;
            obj.dY = Math.abs(rect1.top - rect0.top);
            obj.y0 = Math.max((obj.element.getBoundingClientRect().height - obj.itemH) / 2, 0);
            obj.deltaH = obj.dY * (obj.items.length - 1);
        };
        constructor.resize = () => {
            if (constructor.timeout) { clearTimeout(constructor.timeout); delete constructor.timeout; }
            constructor.timeout = setTimeout(() => {
                constructor.initParams();
                constructor.update();
            }, 50);
        };
        const tl = new TimelineMax({
            paused: true,
            onUpdate: constructor.update
        });

        tl.set(obj, {progress: 0}, 'st');
        tl.to(obj, refDuration * 0.5, {progress: 1}, 'st+=' + refDuration * 0.2);

        constructor.initParams();
        win.addEventListener('resize', constructor.resize);

        constructor.timeline = tl;
        _created = true;
        return tl;
    };

    constructor.destroy = () => {
        if (!_created) return;
        if (constructor.timeout) { clearTimeout(constructor.timeout); delete constructor.timeout; }
        Shortcuts.destroyTimeline(constructor);
        win.removeEventListener('resize', constructor.resize);
        TweenLite.set(selector, {opacity: 0});
        _created = false;
    };

    constructor.startDuration = refDuration * 0.2;
    constructor.totalDuration = refDuration;

    return constructor;
}

module.exports = GallerySliderTimeline;


// WEBPACK FOOTER //
// ./js/viscom/vereschagin/timelines/illustrations/GallerySliderTimeline.js